import axios from "axios";
import NProgress from "nprogress";
import router from "@/router";
import store from "@/store";
import config from '@/assets/js/appsettings.json';
import * as MutationTypes from '@/store/mutation-types'

const max_requests = 10
const interval_ms = 10
let pending_requests = 0

const httpClient = axios.create({
    baseURL: process.env.VUE_APP_API_URL || config.API_URL,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.token
    }
});

// before a request is made start the nprogress
httpClient.interceptors.request.use(config => {
    NProgress.start();

    // Tell the server when this session is PREVIEWING another user ("View as user").
    // A header rather than a query param on nine endpoints: it reaches GETs and POSTs
    // alike and needs no signature churn. It can only ever NARROW what the server
    // returns — the backend uses it to close the internal-account gate, never to open
    // anything — so a forged value costs the forger visibility, not gains it.
    try {
        const raw = localStorage.getItem("viewAsUser");
        const id = raw ? (JSON.parse(raw) || {}).id : null;
        if (id) config.headers["X-View-As-User"] = String(id);
    } catch (e) { /* malformed localStorage must never block a request */ }
    store.commit(MutationTypes.START_LOADING);

    return new Promise(resolve => {
        let interval = setInterval(() => {
            if (pending_requests < max_requests) {
                pending_requests++
                clearInterval(interval)
                resolve(config)
            } 
        }, interval_ms)
      })
}, error => {
    store.commit(MutationTypes.FINISH_LOADING);
    return Promise.reject(error);
  });

// before a response is returned stop nprogress
httpClient.interceptors.response.use(
    response => {
        pending_requests = Math.max(0, pending_requests - 1);
        store.commit(MutationTypes.FINISH_LOADING);

        if (pending_requests == 0) {
            NProgress.done();
        }
        return Promise.resolve(response)
    },
    error => {
        // NProgress.done();
        pending_requests = Math.max(0, pending_requests - 1);

        if (pending_requests == 0) {
            NProgress.done();
        }

        if (error.response.status === 401) {
            delete localStorage.token;
            store.dispatch("logout");
            // Preserve where the user was so login returns them there — covers a
            // STALE token: the router guard passes (it only checks the decoded
            // user, not expiry), the page loads, then the first API call 401s.
            // Without this, deep links like the report-chart email's upload URL
            // were lost at this bounce.
            var full = router.currentRoute && router.currentRoute.fullPath;
            if (full && full.indexOf("/login") !== 0) {
                router.push({ path: "/login", query: { redirect: full } });
            } else {
                router.push("/login");
            }
            router.go(0);
        }

        store.commit(MutationTypes.FINISH_LOADING);
        return Promise.reject({ error });
    }
);

export default httpClient;